import { SearchOutlined } from '@mui/icons-material';
import {
  Box,
  Button,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { FC, useMemo, useState } from 'react';

import { searchSections } from './sections';

/**
 * 設定セクションの検索とジャンプ。
 * 検索語はここだけで使うのでローカルに持つ。
 */
export const SettingsSideNav: FC<{
  activeSectionId: string;
  onSelect: (id: string) => void;
}> = ({ activeSectionId, onSelect }) => {
  const [searchQuery, setSearchQuery] = useState<string>('');
  const sections = useMemo(() => searchSections(searchQuery), [searchQuery]);

  return (
    <Box
      component="nav"
      aria-label="設定セクション"
      sx={{
        width: 248,
        flexShrink: 0,
        borderRight: 1,
        borderColor: 'divider',
        bgcolor: 'background.paper',
        overflowY: 'auto',
      }}
    >
      <Box sx={{ p: 2 }}>
        <TextField
          fullWidth
          size="small"
          value={searchQuery}
          onChange={(event) => setSearchQuery(event.target.value)}
          placeholder="設定を検索"
          inputProps={{ 'aria-label': '設定を検索' }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchOutlined color="action" fontSize="small" />
              </InputAdornment>
            ),
          }}
          sx={{ '& input': { fontSize: 13 } }}
        />
        <Stack spacing={0.5} sx={{ mt: 1.5 }}>
          {sections.length > 0 ? sections.map((section) => {
            const active = activeSectionId === section.id;
            const Icon = section.icon;

            return (
              <Button
                key={section.id}
                size="small"
                fullWidth
                variant={active ? 'contained' : 'text'}
                startIcon={<Icon fontSize="small" />}
                onClick={() => onSelect(section.id)}
                sx={{
                  justifyContent: 'flex-start',
                  minHeight: 34,
                  px: 1.25,
                  fontSize: 12.5,
                  fontWeight: active ? 700 : 500,
                  color: active ? 'primary.contrastText' : 'text.primary',
                }}
              >
                {section.label}
              </Button>
            );
          }) : (
            <Typography sx={{
              py: 0.75, px: 1, fontSize: 12.5, color: 'text.secondary',
            }}
            >
              一致する設定がありません。
            </Typography>
          )}
        </Stack>
      </Box>
    </Box>
  );
};
